/* eslint-disable */

/**
 * A function which checks whether the name of the query param is found in the url
 * https://stackoverflow.com/questions/7731778/get-query-string-parameters-with-jquery
 * @param key
 * @returns {string} whether the provided query name is included in the url
 */
const qs = (key) => {
  key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // escape RegEx meta chars
  var match = location.search.match(new RegExp("[?&]"+key+"=([^&]+)(&|$)"));
  return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

/**
 *
 * @param keys
 * @returns {*} example: &a=1&b=2
 */
const getQueryStringFromKeys = (keys) => {
  return keys.reduce( function (accumulator, key) {
    return accumulator + "&" + key + "=" + getParameterByName(key);
  }, "");
}

/**
 * https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
 * @param name
 * @param url
 * @returns {string|null}
 */
const getParameterByName = (name, url) => {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * has query parameter key
 * checks that at least one of the strings in the input array
 * represent an existing query param
 * @param arr - an array of key names to check against the query keys
 */
const hasQk = (arr) => {
  let queryParams = qk();
  return arr.some( key => queryParams.includes(key) );
}

/**
 *
 * @returns {string[]} an array of the query key names
 */
const qk = () => {
  var arr = location.search.replace(/[?]/g,'').split('&').map((key) => key.split('=')[0]);
  return arr.filter(function(el) { return el; });
}

/** To safe get a chained object property
 * https://stackoverflow.com/questions/23808928/javascript-elegant-way-to-check-nested-object-properties-for-null-undefined
 * usage: get(user, 'loc.foo.bar') // undefined
 * @param obj
 * @param key
 * @returns {*}
 */
const get = (obj, key) => {
  return key.split(".").reduce(function(o, x) {
      return (typeof o == "undefined" || o === null) ? o : o[x];
  }, obj);
}

// Used to escape css string selectors for jQuery
// OpenSource: https://gist.github.com/djcsdy/885418
const escapeSelector = (selector) => {
    return "".replace.call(selector,
            /(^[^_a-zA-Z\u00a0-\uffff]|[^-_a-zA-Z0-9\u00a0-\uffff])/g,
            "\\$1");
}

export {qs, escapeSelector, getParameterByName, hasQk, qk, get, getQueryStringFromKeys};
